module.exports = __webpack_public_path__ + "fonts/Lato-Italic.392d0b76.eot";